import axios from 'axios';
import { installApiAuthTransport } from './authTransport';
import { VITE_AI_SERVICE_URL, VITE_BFF_SERVICE_URL } from '../config/envConfig';

export { registerApiAuthCallbacks, resetApiSession } from './authTransport';
export type { PaginatedResponse } from './types';

export const whitelineApi = axios.create({
  baseURL: VITE_BFF_SERVICE_URL,
  withCredentials: true
});

export const aiChatWhitelineApiNew = axios.create({
  baseURL: VITE_AI_SERVICE_URL,
  withCredentials: true
});

export const guestAiApi = axios.create({
  baseURL: VITE_AI_SERVICE_URL,
  withCredentials: true
});

installApiAuthTransport(whitelineApi, VITE_BFF_SERVICE_URL, false);
installApiAuthTransport(aiChatWhitelineApiNew, VITE_AI_SERVICE_URL, true);